<template>
  <div v-if="getData && getData.message" class="hint-bar">
    <img v-if="getData.icon" class="hint-bar__icon" :src="getData.icon" :alt="getData.iconAlt" />
    <i
      v-if="!getData.icon && getData.variant"
      class="hint-bar__icon"
      :class="[iconVariant, getData.variant ? `hint-bar__icon--${getData.variant}` : '']"
    />
    <p v-if="isContentful" class="hint-bar__message text-paragraph">
      <RichRenderer :richTextData="getData.message" />
    </p>
    <div v-else class="hint-bar__message">
      <p class="text-paragraph" @click="$emit('clicked', $event)" v-html="getData.message" />
      <slot />
    </div>
    <i v-if="hasClose" class="icon-close hint-bar__close" @click="$emit('close')" />
  </div>
</template>
<script>
import { getCurrentInstance } from 'vue'

import { useContentfulAutowireGlobal } from '@/components/common/contentful/composables/useContentfulAutowireGlobal'
import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

export default {
  name: 'HintBar',
  props: {
    hintData: {
      type: Object,
      required: false,
      default: () => {},
    },
    isContentful: {
      type: Boolean,
      default: false,
    },
    hasClose: {
      type: Boolean,
      default: false,
    },
    parentComponentName: {
      type: String,
      required: false,
      default: '',
    },
    isAutoWired: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['clicked', 'close'],
  setup(props) {
    const instance = getCurrentInstance()
    const componentName = instance.type.name || ''
    const { getImageUrl, getImageAlt } = useContentfulComponent()

    if (props.isAutoWired) {
      useContentfulAutowireGlobal({
        componentName,
        parentComponentName: props.parentComponentName,
        isContentfulAutowireOn: props.isContentful,
      })
    }

    return {
      getImageUrl,
      getImageAlt,
    }
  },
  data() {
    return {
      data: {},
    }
  },
  computed: {
    iconVariant() {
      switch (this.hintData.variant) {
        case 'success':
          return 'icon-check'
        default:
          return 'icon-info'
      }
    },
    getData() {
      return this.hintData || this.data
    },
  },
  methods: {
    initData(entry) {
      if (entry) {
        this.data = { ...entry }
        this.data.icon = this.getImageUrl(entry.icon)
        this.data.iconAlt = this.getImageAlt(entry.icon)
      }
    },
  },
}
</script>
